import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import MasterLayout from './pages/MasterLayout';
import NewInspection from './pages/NewInspection';
import InspectionMenu from './pages/InspectionMenu';
import SteeringInspection from './pages/SteeringInspection';
import EngineInspection from './pages/EngineInspection';
import ComputerInspection from './pages/ComputerInspection';
import BodyInspection from './pages/BodyInspection';
import DynamicInspectionSection from './pages/DynamicInspectionSection';
import Report from './pages/Report';
import Settings from './pages/Settings';

export default function App() {
  return (
    <div dir="rtl" className="min-h-screen bg-slate-50 text-slate-900">
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/master"
            element={
              <PrivateRoute adminOnly>
                <MasterLayout />
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute adminOnly>
                <Settings />
              </PrivateRoute>
            }
          />

          <Route
            path="/inspection/new"
            element={
              <PrivateRoute>
                <NewInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/edit"
            element={
              <PrivateRoute>
                <NewInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/menu"
            element={
              <PrivateRoute>
                <InspectionMenu />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/steering"
            element={
              <PrivateRoute>
                <SteeringInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/engine"
            element={
              <PrivateRoute>
                <EngineInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/computer"
            element={
              <PrivateRoute>
                <ComputerInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/body"
            element={
              <PrivateRoute>
                <BodyInspection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/:sectionPath"
            element={
              <PrivateRoute>
                <DynamicInspectionSection />
              </PrivateRoute>
            }
          />
          <Route
            path="/inspection/:id/report"
            element={
              <PrivateRoute>
                <Report />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}
